import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IModuleBalances } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getTotalValueBondedConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_module_balances', timeframe)) as IModuleBalances[]
	const series1 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BOND_MODULE_BALANCE }
	})
	const series2 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BOND_MODULE_BALANCE_USD }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'tv bonded [rune]',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'tv bonded [usd]',
			type: 'line',
			seriesGroup: '[usd]',
			color: 'orange',
			unitSymbol: '$'
		}
	]

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TotalValueBonded = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTotalValueBondedConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Value Bonded"
			chartDesc="Total value of RUNE bonded by node operators."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="b36f1290-e971-4dfc-84b7-792674bf63c4"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default TotalValueBonded
